const DataAnalysis = () => {
  return (
    <div>
      <h1>Data Analysis</h1>
    </div>
  );
};

export default DataAnalysis;